//NPM Packages
import React from "react";
import { createBrowserHistory } from "history";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

//Theme
import { ThemeProvider } from "styled-components";
import { theme } from "./styles/Theme";

//Context
import MyProvider from "../context/MyProvider";

import Footer from "../components/Shared/Footer";
import DemoLeads from "../routes/DemoLeads";
import DemoVehicleInurance from "../routes/DemoVehicleInurance";
import DocsForm from "../routes/DocsForm";

const history = createBrowserHistory();

function App() {
  return (
    <div className="main-container">
      <ThemeProvider theme={theme}>
        <Router history={history}>
          <MyProvider>
            <Routes>
              <Route path="/docs" element={<DocsForm />} />
              <Route path="/leadform" element={<DemoLeads />} />
              <Route
                path="/vehicle-insurance"
                element={<DemoVehicleInurance />}
              />
            </Routes>
            <Footer />
          </MyProvider>
        </Router>
      </ThemeProvider>
    </div>
  );
}

export default App;
